export default "__VITE_ASSET__BwLqfijh__"